export const BACKGROUNDS = [
  { value: 'transparent', label: 'Match page', color: null },
  { value: '#ffffff', label: 'White', color: '#ffffff' },
  { value: '#172521', label: 'Charcoal', color: '#172521' },
  { value: '#e7f4ed', label: 'Mint', color: '#e7f4ed' },
  { value: '#dceff8', label: 'Sky', color: '#dceff8' },
  { value: '#fff2cf', label: 'Soft gold', color: '#fff2cf' },
];
export const SPEEDS = [0.75, 1, 1.25];
export const EAGLE_STYLES = [{ value: 'cartoon', label: 'Cartoon' }, { value: 'realistic', label: 'Realistic' }];
export const DEFAULT_PREFERENCES = { eagleStyle: 'cartoon', background: 'transparent', speed: 1, paused: false };
export const preferenceKey = userId => `parseeker.home-eagle.v1:${userId || 'guest'}`;
export const normalizePreferences = value => ({
  eagleStyle: EAGLE_STYLES.some(style => style.value === value?.eagleStyle) ? value.eagleStyle : 'cartoon',
  background: value?.background === 'transparent' || /^#[0-9a-f]{6}$/i.test(value?.background || '') ? value.background : 'transparent',
  speed: SPEEDS.includes(value?.speed) ? value.speed : 1,
  paused: typeof value?.paused === 'boolean' ? value.paused : false,
});
export const readPreferences = userId => {
  try { return normalizePreferences(JSON.parse(localStorage.getItem(preferenceKey(userId)))); }
  catch { return { ...DEFAULT_PREFERENCES }; }
};
export const writePreferences = (userId, value) => {
  try { localStorage.setItem(preferenceKey(userId), JSON.stringify(normalizePreferences(value))); return true; }
  catch { return false; }
};
export const frameAt = (elapsed, duration, frames) => Math.floor(((Math.max(0, elapsed) % duration) / duration) * frames);